import { useEffect } from 'react';

export default function UseInstagramEmbed() {
  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
      return;
    }

    const script = document.createElement('script');
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    script.onload = () => window.instgrm?.Embeds?.process();
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
}